import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { PrimaryButtonComponent } from '../primary-button/primary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-success-dialog',
  imports: [MatIcon, PrimaryButtonComponent, TranslocoPipe],
  templateUrl: './success-dialog.component.html',
  styleUrl: './success-dialog.component.css',
})
export class SuccessDialogComponent {
  protected data = inject<{
    title: string;
    description: string;
    buttonText: string;
    descriptionParams?: Record<string, string>;
  }>(MAT_DIALOG_DATA);
  protected readonly dialogRef =
    inject<MatDialogRef<SuccessDialogComponent>>(MatDialogRef);
}
